module.exports = __webpack_public_path__ + "static/media/FD1.0361b5f8.jpg";